export default __webpack_public_path__ + "static/media/product-18.1c26f2c8.webp";